export type Language = 'en' | 'ua' | 'ru' | 'ro'

export const translations = {
  // Navigation
  nav: {
    home: { en: 'Home', ua: 'Головна', ru: 'Главная', ro: 'Acasă' },
    services: { en: 'Services', ua: 'Послуги', ru: 'Услуги', ro: 'Servicii' },
    prices: { en: 'Prices', ua: 'Ціни', ru: 'Цены', ro: 'Prețuri' },
    about: { en: 'About Us', ua: 'Про нас', ru: 'О нас', ro: 'Despre noi' },
    contact: { en: 'Contact', ua: 'Контакти', ru: 'Контакты', ro: 'Contact' },
    bookOnline: {
      en: 'Book Online',
      ua: 'Записатись',
      ru: 'Записаться',
      ro: 'Programare',
    },
  },

  // Hero Section
  hero: {
    badge: {
      en: 'Accepting new patients',
      ua: 'Ми розмовляємо українською',
      ru: 'Мы говорим по-русски',
      ro: 'Acceptăm pacienți noi',
    },
    title: {
      en: 'Private Dental Clinic in',
      ua: 'Український стоматолог у Лондоні —',
      ru: 'Русскоязычный стоматолог в Лондоне —',
      ro: 'Clinică stomatologică privată în',
    },
    titleHighlight: {
      en: 'Angel, London',
      ua: 'Dentico Clinic',
      ru: 'Dentico Clinic',
      ro: 'Angel, Londra',
    },
    description: {
      en: 'Dentico Clinic is a modern private dental clinic in Angel, Central London. We provide high-quality dental care using advanced technology, experienced clinicians, and transparent private fees.',
      ua: 'Dentico Clinic — приватна стоматологічна клініка в Лондоні з українськомовними лікарями. Ми зрозуміло пояснюємо лікування, працюємо чесно та використовуємо сучасне обладнання.',
      ru: 'Dentico Clinic — частная стоматология в Лондоне с русскоязычными врачами. Понятные объяснения лечения и современное оборудование.',
      ro: 'Dentico Clinic este o clinică stomatologică privată modernă în Angel, Londra Centrală. Oferim îngrijire dentară de înaltă calitate folosind tehnologie avansată, medici experimentați și tarife transparente.',
    },
    whatsapp: {
      en: 'WhatsApp Us',
      ua: 'WhatsApp',
      ru: 'WhatsApp',
      ro: 'WhatsApp',
    },
  },

  // Features
  features: {
    nativeLanguage: {
      en: 'Experienced private dentists',
      ua: 'Українськомовні стоматологи',
      ru: 'Русскоязычные стоматологи',
      ro: 'Stomatologi experimentați privați',
    },
    modernDentistry: {
      en: 'Modern digital dentistry',
      ua: 'Сучасне обладнання',
      ru: 'Современное оборудование',
      ro: 'Stomatologie digitală modernă',
    },
    experiencedDentists: {
      en: 'Experienced private dentists',
      ua: 'Досвідчені лікарі',
      ru: 'Опытные врачи',
      ro: 'Medici stomatologi experimentați',
    },
    clearPlans: {
      en: 'Clear treatment plans',
      ua: 'Зрозуміле пояснення лікування',
      ru: 'Понятные объяснения лечения',
      ro: 'Planuri de tratament clare',
    },
    honestPricing: {
      en: 'Honest private pricing',
      ua: 'Чесні ціни',
      ru: 'Честные цены',
      ro: 'Prețuri oneste',
    },
    excellentReviews: {
      en: 'Excellent patient reviews',
      ua: 'Онлайн-запис',
      ru: 'Онлайн-запись',
      ro: 'Recenzii excelente ale pacienților',
    },
    convenientLocation: {
      en: 'Convenient location near Angel station',
      ua: 'Зручне розташування (Angel)',
      ru: 'Удобное расположение (Angel)',
      ro: 'Locație convenabilă lângă stația Angel',
    },
  },

  // Services Section
  services: {
    title: {
      en: 'Comprehensive Dental Services',
      ua: 'Наші Послуги',
      ru: 'Наши Услуги',
      ro: 'Servicii Stomatologice Complete',
    },
    subtitle: {
      en: 'From routine check-ups to complex smile makeovers, our experienced team is here to help you achieve optimal oral health.',
      ua: 'Повний спектр стоматологічних послуг від професійної гігієни до складного протезування.',
      ru: 'Полный спектр стоматологических услуг от профессиональной гигиены до сложного протезирования.',
      ro: 'De la controale de rutină la transformări complexe ale zâmbetului, echipa noastră experimentată este aici să vă ajute.',
    },
    learnMore: {
      en: 'Learn more',
      ua: 'Детальніше',
      ru: 'Подробнее',
      ro: 'Află mai multe',
    },
    viewAll: {
      en: 'View All Services',
      ua: 'Всі послуги',
      ru: 'Все услуги',
      ro: 'Toate serviciile',
    },
    general: {
      title: {
        en: 'General Dentistry',
        ua: 'Загальна стоматологія',
        ru: 'Общая стоматология',
        ro: 'Stomatologie Generală',
      },
      desc: {
        en: 'Comprehensive check-ups and hygiene services for your oral health.',
        ua: "Комплексні огляди та гігієна для здоров'я вашої посмішки.",
        ru: 'Комплексные осмотры и гигиена для здоровья вашей улыбки.',
        ro: 'Controale complete și servicii de igienă pentru sănătatea dumneavoastră orală.',
      },
      fullDesc: {
        en: 'Regular check-ups and hygiene appointments are the foundation of a healthy smile. We focus on prevention and early detection.',
        ua: 'Регулярні огляди та гігієнічні процедури є основою здорової посмішки. Ми зосереджуємось на профілактиці та ранньому виявленні.',
        ru: 'Регулярные осмотры и гигиенические процедуры являются основой здоровой улыбки. Мы фокусируемся на профилактике и раннем выявлении.',
        ro: 'Controalele regulate și igienizările sunt baza unui zâmbet sănătos. Ne concentrăm pe prevenție și detectare timpurie.',
      },
      benefits: {
        en: [
          'Comprehensive oral health check',
          'Scale and polish',
          'Oral cancer screening',
          'Preventative advice',
        ],
        ua: [
          'Комплексний огляд порожнини рота',
          'Чистка та полірування',
          'Скринінг раку порожнини рота',
          'Профілактичні поради',
        ],
        ru: [
          'Комплексный осмотр полости рта',
          'Чистка и полировка',
          'Скрининг рака полости рта',
          'Профилактические советы',
        ],
        ro: [
          'Control complet al sănătății orale',
          'Detartraj și periaj',
          'Screening pentru cancer oral',
          'Sfaturi preventive',
        ],
      },
    },
    fillings: {
      title: {
        en: 'Dental Fillings in London',
        ua: 'Пломбування та реставрація зубів',
        ru: 'Пломбирование зубов',
        ro: 'Plombe Dentare',
      },
      desc: {
        en: 'Aesthetic white fillings to restore teeth naturally.',
        ua: 'Естетичні фотополімерні пломби, що виглядають природно.',
        ru: 'Эстетические фотополимерные пломбы, которые выглядят естественно.',
        ro: 'Plombe albe estetice pentru a restaura dinții natural.',
      },
      fullDesc: {
        en: 'We use high-quality white composite fillings that match your natural tooth shade. No more unsightly metal amalgam fillings.',
        ua: 'Ми використовуємо високоякісні білі композитні пломби, які відповідають природному відтінку ваших зубів.',
        ru: 'Мы используем высококачественные белые композитные пломбы, которые соответствуют естественному оттенку ваших зубов.',
        ro: 'Folosim plombe compozite albe de înaltă calitate care se potrivesc cu nuanța naturală a dintelui dumneavoastră.',
      },
      benefits: {
        en: [
          'Natural appearance',
          'Mercury-free materials',
          'Durable and long-lasting',
          'Minimally invasive',
        ],
        ua: [
          'Природний вигляд',
          'Матеріали без ртуті',
          'Довговічність',
          'Мінімально інвазивні',
        ],
        ru: [
          'Естественный вид',
          'Материалы без ртути',
          'Долговечность',
          'Минимально инвазивные',
        ],
        ro: [
          'Aspect natural',
          'Materiale fără mercur',
          'Durabil și de lungă durată',
          'Minim invaziv',
        ],
      },
    },
    rootCanal: {
      title: {
        en: 'Root Canal Treatment in London',
        ua: 'Лікування та перелікування каналів',
        ru: 'Лечение каналов',
        ro: 'Tratament de Canal',
      },
      desc: {
        en: 'Pain-free treatment to save infected teeth.',
        ua: 'Безболісне лікування для збереження інфікованих зубів.',
        ru: 'Безболезненное лечение для сохранения инфицированных зубов.',
        ro: 'Tratament fără durere pentru a salva dinții infectați.',
      },
      fullDesc: {
        en: 'Modern root canal treatment is virtually pain-free. We save infected teeth that would otherwise need extraction.',
        ua: 'Сучасне лікування кореневих каналів практично безболісне. Ми зберігаємо інфіковані зуби, які інакше потребували б видалення.',
        ru: 'Современное лечение корневых каналов практически безболезненно. Мы сохраняем инфицированные зубы, которые иначе потребовали бы удаления.',
        ro: 'Tratamentul modern de canal este practic fără durere. Salvăm dinții infectați care altfel ar necesita extracție.',
      },
      benefits: {
        en: [
          'Save your natural tooth',
          'Relieve tooth pain immediately',
          'Advanced rotary technology',
          'High success rate',
        ],
        ua: [
          'Збережіть свій природний зуб',
          'Негайне полегшення болю',
          'Сучасна ротаційна технологія',
          'Високий відсоток успіху',
        ],
        ru: [
          'Сохраните свой естественный зуб',
          'Немедленное облегчение боли',
          'Современная ротационная технология',
          'Высокий процент успеха',
        ],
        ro: [
          'Salvați-vă dintele natural',
          'Ameliorarea imediată a durerii',
          'Tehnologie rotativă avansată',
          'Rată mare de succes',
        ],
      },
    },
    crowns: {
      title: {
        en: 'Dental Crowns in London',
        ua: 'Коронки та протезування',
        ru: 'Зубные коронки',
        ro: 'Coroane Dentare',
      },
      desc: {
        en: 'Durable and natural-looking restoration for damaged teeth.',
        ua: 'Надійне та естетичне відновлення пошкоджених зубів.',
        ru: 'Надежное и эстетичное восстановление поврежденных зубов.',
        ro: 'Restaurare durabilă și cu aspect natural pentru dinții deteriorați.',
      },
      fullDesc: {
        en: 'Restore broken or weak teeth with our custom-made ceramic crowns. They look and feel just like your natural teeth.',
        ua: 'Відновіть зламані або слабкі зуби за допомогою наших керамічних коронок на замовлення.',
        ru: 'Восстановите сломанные или слабые зубы с помощью наших керамических коронок на заказ.',
        ro: 'Restaurați dinții rupți sau slăbiți cu coroanele noastre ceramice personalizate. Arată și se simt exact ca dinții dumneavoastră naturali.',
      },
      benefits: {
        en: [
          'Strengthen damaged teeth',
          'Improve appearance',
          'Long-lasting solution',
          'Custom color matching',
        ],
        ua: [
          'Зміцнення пошкоджених зубів',
          'Покращення зовнішнього вигляду',
          'Довготривале рішення',
          'Індивідуальний підбір кольору',
        ],
        ru: [
          'Укрепление поврежденных зубов',
          'Улучшение внешнего вида',
          'Долгосрочное решение',
          'Индивидуальный подбор цвета',
        ],
        ro: [
          'Întărirea dinților deteriorați',
          'Îmbunătățirea aspectului',
          'Soluție de lungă durată',
          'Potrivire personalizată a culorii',
        ],
      },
    },
    hygiene: {
      title: {
        en: 'Dental Hygiene in London',
        ua: 'Професійна гігієна',
        ru: 'Профессиональная гигиена',
        ro: 'Igienă Dentară',
      },
      desc: {
        en: 'Professional cleaning for a healthier smile.',
        ua: 'Професійна чистка для здорової посмішки.',
        ru: 'Профессиональная чистка для здоровой улыбки.',
        ro: 'Curățare profesională pentru un zâmbet mai sănătos.',
      },
      fullDesc: {
        en: 'Regular professional cleaning removes plaque and tartar that brushing alone cannot reach, preventing gum disease and tooth decay.',
        ua: 'Регулярна професійна чистка видаляє наліт і зубний камінь, запобігаючи захворюванням ясен та карієсу.',
        ru: 'Регулярная профессиональная чистка удаляет налет и зубной камень, предотвращая заболевания десен и кариес.',
        ro: 'Curățarea profesională regulată îndepărtează placa și tartrul pe care periajul singur nu le poate atinge, prevenind bolile gingivale și cariile.',
      },
      benefits: {
        en: [
          'Remove plaque and tartar',
          'Prevent gum disease',
          'Fresher breath',
          'Brighter smile',
        ],
        ua: [
          'Видалення нальоту та каменю',
          'Профілактика захворювань ясен',
          'Свіже дихання',
          'Яскравіша посмішка',
        ],
        ru: [
          'Удаление налета и камня',
          'Профилактика заболеваний десен',
          'Свежее дыхание',
          'Яркая улыбка',
        ],
        ro: [
          'Îndepărtarea plăcii și tartrului',
          'Prevenirea bolilor gingivale',
          'Respirație mai proaspătă',
          'Zâmbet mai strălucitor',
        ],
      },
    },
    whitening: {
      title: {
        en: 'Teeth Whitening in London',
        ua: 'Відбілювання зубів',
        ru: 'Отбеливание зубов',
        ro: 'Albirea Dinților',
      },
      desc: {
        en: 'Professional whitening for a brighter smile.',
        ua: 'Професійне відбілювання для яскравої посмішки.',
        ru: 'Профессиональное отбеливание для яркой улыбки.',
        ro: 'Albire profesională pentru un zâmbet mai strălucitor.',
      },
      fullDesc: {
        en: 'Our professional whitening treatments can lighten your teeth by several shades, giving you a confident, radiant smile.',
        ua: 'Наші професійні процедури відбілювання можуть освітлити ваші зуби на кілька тонів.',
        ru: 'Наши профессиональные процедуры отбеливания могут осветлить ваши зубы на несколько тонов.',
        ro: 'Tratamentele noastre profesionale de albire vă pot deschide dinții cu câteva nuanțe, oferindu-vă un zâmbet încrezător și radiant.',
      },
      benefits: {
        en: [
          'Safe and effective',
          'Long-lasting results',
          'Custom treatment',
          'Immediate improvement',
        ],
        ua: [
          'Безпечно та ефективно',
          'Тривалий результат',
          'Індивідуальний підхід',
          'Негайне покращення',
        ],
        ru: [
          'Безопасно и эффективно',
          'Длительный результат',
          'Индивидуальный подход',
          'Немедленное улучшение',
        ],
        ro: [
          'Sigur și eficient',
          'Rezultate de lungă durată',
          'Tratament personalizat',
          'Îmbunătățire imediată',
        ],
      },
    },
    extraction: {
      title: {
        en: 'Tooth Extraction in London',
        ua: 'Видалення зубів',
        ru: 'Удаление зубов',
        ro: 'Extracția Dinților',
      },
      desc: {
        en: 'Safe and gentle tooth removal when needed.',
        ua: 'Безпечне та делікатне видалення зубів.',
        ru: 'Безопасное и деликатное удаление зубов.',
        ro: 'Îndepărtare sigură și blândă a dintelui atunci când este necesar.',
      },
      fullDesc: {
        en: 'When a tooth cannot be saved, we perform gentle extractions with minimal discomfort and provide guidance for healing.',
        ua: 'Коли зуб неможливо зберегти, ми проводимо делікатне видалення з мінімальним дискомфортом.',
        ru: 'Когда зуб невозможно сохранить, мы проводим деликатное удаление с минимальным дискомфортом.',
        ro: 'Când un dinte nu poate fi salvat, efectuăm extracții blânde cu disconfort minim și oferim îndrumări pentru vindecare.',
      },
      benefits: {
        en: [
          'Gentle technique',
          'Pain management',
          'Quick recovery',
          'Aftercare guidance',
        ],
        ua: [
          'Делікатна техніка',
          'Знеболення',
          'Швидке відновлення',
          'Рекомендації по догляду',
        ],
        ru: [
          'Деликатная техника',
          'Обезболивание',
          'Быстрое восстановление',
          'Рекомендации по уходу',
        ],
        ro: [
          'Tehnică blândă',
          'Managementul durerii',
          'Recuperare rapidă',
          'Îndrumări post-extracție',
        ],
      },
    },
    cosmetic: {
      title: {
        en: 'Cosmetic Injections',
        ua: "Ін'єкційна косметологія",
        ru: 'Инъекционная косметология',
        ro: 'Injecții Cosmetice',
      },
      desc: {
        en: 'Facial aesthetics to complement your smile.',
        ua: 'Естетичні процедури для обличчя.',
        ru: 'Эстетические процедуры для лица.',
        ro: 'Estetică facială pentru a vă completa zâmbetul.',
      },
      fullDesc: {
        en: 'Enhance your appearance with our range of cosmetic injection treatments performed by trained professionals.',
        ua: 'Покращіть свій зовнішній вигляд за допомогою наших косметичних процедур.',
        ru: 'Улучшите свой внешний вид с помощью наших косметических процедур.',
        ro: 'Îmbunătățiți-vă aspectul cu gama noastră de tratamente cu injecții cosmetice efectuate de profesioniști instruiți.',
      },
      benefits: {
        en: [
          'Natural results',
          'Minimal downtime',
          'Trained professionals',
          'Personalized treatment',
        ],
        ua: [
          'Природний результат',
          'Мінімальний час відновлення',
          'Кваліфіковані спеціалісти',
          'Індивідуальний підхід',
        ],
        ru: [
          'Естественный результат',
          'Минимальное время восстановления',
          'Квалифицированные специалисты',
          'Индивидуальный подход',
        ],
        ro: [
          'Rezultate naturale',
          'Timp minim de recuperare',
          'Profesioniști instruiți',
          'Tratament personalizat',
        ],
      },
    },
    paediatric: {
      title: {
        en: 'Paediatric Dentistry',
        ua: 'Дитяча стоматологія',
        ru: 'Детская стоматология',
        ro: 'Stomatologie pediatrică',
      },
      desc: {
        en: 'Gentle dental care for children: check-ups, fillings, pain, trauma, baby teeth and preventive visits.',
        ua: 'Дбайлива стоматологічна допомога дітям: огляди, пломби, біль, травми, молочні зуби та профілактичні візити.',
        ru: 'Бережная стоматологическая помощь детям: осмотры, пломбы, боль, травмы, молочные зубы и профилактические визиты.',
        ro: 'Îngrijire dentară delicată pentru copii: controale, plombe, durere, traumatisme, dinți de lapte și vizite preventive.',
      },
    },
    smileMakeover: {
      title: {
        en: 'Smile Makeover in London | Veneers, Bonding & Cosmetic Dentistry',
        ua: 'Smile Makeover — Естетична стоматологія в Лондоні',
        ru: 'Smile Makeover — Эстетическая стоматология в Лондоне',
        ro: 'Transformarea Zâmbetului',
      },
      desc: {
        en: 'Transform your smile with veneers, bonding, and whitening.',
        ua: 'Вініри, накладки, вкладки, відбілювання та повна трансформація посмішки.',
        ru: 'Виниры, накладки, вкладки, отбеливание и полная трансформация улыбки.',
        ro: 'Transformați-vă zâmbetul cu fațete, bonding și albire.',
      },
      fullDesc: {
        en: 'A Smile Makeover is a comprehensive cosmetic dental treatment that combines multiple procedures to transform your smile. Using digital smile design, we create a personalized treatment plan that may include porcelain veneers, composite bonding, teeth whitening, and muscle relaxation treatments. Our advanced photo protocol and 3D scanning ensure predictable, stunning results.',
        ua: "Smile Makeover — це комплексне естетичне лікування, яке поєднує кілька процедур для повної трансформації вашої посмішки. Використовуючи цифровий дизайн посмішки, ми створюємо індивідуальний план лікування, який може включати керамічні вініри, композитні накладки, вкладки, відбілювання та розслаблення м'язів. Наш сучасний фотопротокол та 3D-сканування забезпечують передбачуваний та вражаючий результат.",
        ru: 'Smile Makeover — это комплексное эстетическое лечение, которое объединяет несколько процедур для полной трансформации вашей улыбки. Используя цифровой дизайн улыбки, мы создаем индивидуальный план лечения, который может включать керамические виниры, композитные накладки, вкладки, отбеливание и расслабление мышц. Наш современный фотопротокол и 3D-сканирование обеспечивают предсказуемый и впечатляющий результат.',
        ro: 'Transformarea Zâmbetului este un tratament stomatologic cosmetic complex care combină mai multe proceduri pentru a vă transforma zâmbetul. Folosind designul digital al zâmbetului, creăm un plan de tratament personalizat care poate include fațete din porțelan, bonding compozit, albirea dinților și tratamente de relaxare musculară. Protocolul nostru foto avansat și scanarea 3D asigură rezultate previzibile și uimitoare.',
      },
      seoDescription: {
        en: 'Professional Smile Makeover in Angel, London. Transform your smile with porcelain veneers, composite bonding, teeth whitening. Digital smile design, before & after photos. Book consultation at Dentico Clinic.',
        ua: 'Професійний Smile Makeover в Лондоні, район Angel. Трансформація посмішки: вініри, накладки, відбілювання. Цифровий дизайн посмішки, фото до та після. Українськомовний стоматолог. Запис у Dentico Clinic.',
        ru: 'Профессиональный Smile Makeover в Лондоне, район Angel. Трансформация улыбки: виниры, накладки, отбеливание. Цифровой дизайн улыбки, фото до и после. Русскоязычный стоматолог. Запись в Dentico Clinic.',
        ro: 'Transformarea Zâmbetului profesională în Angel, Londra. Transformați-vă zâmbetul cu fațete din porțelan, bonding compozit, albirea dinților. Design digital al zâmbetului, fotografii înainte și după. Programați o consultație la Dentico Clinic.',
      },
      benefits: {
        en: [
          'Digital Smile Design with 3D scanning',
          'Porcelain veneers & composite bonding',
          'Professional teeth whitening',
          'Muscle relaxation treatments',
          'Comprehensive photo protocol',
          'Natural-looking, long-lasting results',
        ],
        ua: [
          'Цифровий дизайн посмішки з 3D-скануванням',
          'Керамічні вініри та композитні накладки',
          'Професійне відбілювання зубів',
          "Розслаблення м'язів обличчя",
          'Комплексний фотопротокол',
          'Природний та довготривалий результат',
        ],
        ru: [
          'Цифровой дизайн улыбки с 3D-сканированием',
          'Керамические виниры и композитные накладки',
          'Профессиональное отбеливание зубов',
          'Расслабление мышц лица',
          'Комплексный фотопротокол',
          'Естественный и долговечный результат',
        ],
        ro: [
          'Design Digital al Zâmbetului cu scanare 3D',
          'Fațete din porțelan și bonding compozit',
          'Albirea profesională a dinților',
          'Tratamente de relaxare musculară',
          'Protocol foto complex',
          'Rezultate cu aspect natural, de lungă durată',
        ],
      },
      treatments: {
        en: [
          {
            name: 'Porcelain Veneers',
            desc: 'Ultra-thin ceramic shells for a perfect smile',
          },
          {
            name: 'Composite Bonding',
            desc: 'Tooth-colored resin to reshape and restore',
          },
          {
            name: 'Teeth Whitening',
            desc: 'Professional whitening for a brighter smile',
          },
          {
            name: 'Inlays & Onlays',
            desc: 'Custom ceramic restorations for damaged teeth',
          },
          {
            name: 'Muscle Relaxation',
            desc: 'Facial aesthetics to complement your smile',
          },
          {
            name: '3D Scanning & Photo Protocol',
            desc: 'Digital planning for predictable results',
          },
        ],
        ua: [
          {
            name: 'Керамічні вініри',
            desc: 'Ультратонкі керамічні накладки для ідеальної посмішки',
          },
          {
            name: 'Композитні накладки',
            desc: 'Реставрація зубів композитним матеріалом',
          },
          {
            name: 'Відбілювання зубів',
            desc: 'Професійне відбілювання для яскравої посмішки',
          },
          {
            name: 'Вкладки та накладки',
            desc: 'Індивідуальні керамічні реставрації',
          },
          {
            name: "Розслаблення м'язів",
            desc: 'Естетичні процедури для обличчя',
          },
          {
            name: '3D-сканування та фотопротокол',
            desc: 'Цифрове планування для передбачуваного результату',
          },
        ],
        ru: [
          {
            name: 'Керамические виниры',
            desc: 'Ультратонкие керамические накладки для идеальной улыбки',
          },
          {
            name: 'Композитные накладки',
            desc: 'Реставрация зубов композитным материалом',
          },
          {
            name: 'Отбеливание зубов',
            desc: 'Профессиональное отбеливание для яркой улыбки',
          },
          {
            name: 'Вкладки и накладки',
            desc: 'Индивидуальные керамические реставрации',
          },
          {
            name: 'Расслабление мышц',
            desc: 'Эстетические процедуры для лица',
          },
          {
            name: '3D-сканирование и фотопротокол',
            desc: 'Цифровое планирование для предсказуемого результата',
          },
        ],
        ro: [
          {
            name: 'Fațete din Porțelan',
            desc: 'Învelișuri ceramice ultra-subțiri pentru un zâmbet perfect',
          },
          {
            name: 'Bonding Compozit',
            desc: 'Rășină de culoarea dintelui pentru remodelare și restaurare',
          },
          {
            name: 'Albirea Dinților',
            desc: 'Albire profesională pentru un zâmbet mai strălucitor',
          },
          {
            name: 'Inlay-uri & Onlay-uri',
            desc: 'Restaurări ceramice personalizate pentru dinți deteriorați',
          },
          {
            name: 'Relaxare Musculară',
            desc: 'Estetică facială pentru a vă completa zâmbetul',
          },
          {
            name: 'Scanare 3D & Protocol Foto',
            desc: 'Planificare digitală pentru rezultate previzibile',
          },
        ],
      },
      gallery: {
        title: {
          en: 'Before & After Results',
          ua: 'Результати: До та Після',
          ru: 'Результаты: До и После',
          ro: 'Rezultate: Înainte și După',
        },
        uploadPlaceholder: {
          en: 'Photo coming soon',
          ua: 'Фото незабаром',
          ru: 'Фото скоро',
          ro: 'Fotografie în curând',
        },
      },
      video: {
        title: {
          en: 'Watch Our Smile Transformations',
          ua: 'Дивіться трансформації посмішок',
          ru: 'Смотрите трансформации улыбок',
          ro: 'Urmăriți Transformările Zâmbetului',
        },
        placeholder: {
          en: 'Video coming soon',
          ua: 'Відео незабаром',
          ru: 'Видео скоро',
          ro: 'Video în curând',
        },
      },
    },
  },

  // Prices Page
  prices: {
    title: {
      en: 'Private Dental Fees in London',
      ua: 'Ціни на стоматологічні послуги',
      ru: 'Цены на стоматологические услуги',
      ro: 'Tarife Stomatologice Private în Londra',
    },
    subtitle: {
      en: 'Transparent pricing for all our dental treatments. No hidden fees.',
      ua: 'Прозорі ціни на всі наші стоматологічні послуги. Без прихованих платежів.',
      ru: 'Прозрачные цены на все наши стоматологические услуги. Без скрытых платежей.',
      ro: 'Prețuri transparente pentru toate tratamentele noastre stomatologice. Fără taxe ascunse.',
    },
    note: {
      en: 'Exact fees depend on clinical assessment. Please book a consultation for a personalized treatment plan.',
      ua: 'Точна вартість залежить від клінічної оцінки. Запишіться на консультацію для індивідуального плану лікування.',
      ru: 'Точная стоимость зависит от клинической оценки. Запишитесь на консультацию для индивидуального плана лечения.',
      ro: 'Tarifele exacte depind de evaluarea clinică. Vă rugăm să programați o consultație pentru un plan de tratament personalizat.',
    },
    consultation: {
      en: 'Consultation',
      ua: 'Консультація',
      ru: 'Консультация',
      ro: 'Consultație',
    },
    consultationPrice: { en: '£20', ua: '£20', ru: '£20', ro: '£20' },
    examination: {
      en: 'Dental Examination',
      ua: 'Огляд стоматолога',
      ru: 'Осмотр стоматолога',
      ro: 'Examinare Dentară',
    },
    examinationPrice: { en: '£50', ua: '£35', ru: '£35', ro: '£35' },
    xray: {
      en: 'X-Ray (per image)',
      ua: 'Рентген (1 знімок)',
      ru: 'Рентген (1 снимок)',
      ro: 'Radiografie (per imagine)',
    },
    xrayPrice: { en: '£20', ua: '£20', ru: '£20', ro: '£20' },
    filling: {
      en: 'Dental Filling',
      ua: 'Пломба',
      ru: 'Пломба',
      ro: 'Plombă Dentară',
    },
    fillingPrice: {
      en: '£130–£220',
      ua: '£100–£170',
      ru: '£100–£170',
      ro: '£100–£170',
    },
    rootCanal: {
      en: 'Root Canal Treatment',
      ua: 'Лікування каналів',
      ru: 'Лечение каналов',
      ro: 'Tratament de Canal',
    },
    rootCanalPrice: {
      en: 'from £320',
      ua: 'від £350',
      ru: 'от £350',
      ro: 'de la £350',
    },
    crown: {
      en: 'Dental Crown',
      ua: 'Коронка',
      ru: 'Коронка',
      ro: 'Coroană Dentară',
    },
    crownPrice: {
      en: '£600–£850',
      ua: '£500–£650',
      ru: '£500–£650',
      ro: '£500–£650',
    },
    hygiene: {
      en: 'Dental Hygiene (Scale & Polish)',
      ua: 'Гігієна (ультразвук + полірування)',
      ru: 'Гигиена (ультразвук + полировка)',
      ro: 'Igienă Dentară (Detartraj și Periaj)',
    },
    hygienePrice: { en: '£120', ua: '£100', ru: '£100', ro: '£100' },
    hygieneAirflow: {
      en: 'Dental Hygiene with Airflow',
      ua: 'Гігієна з Airflow',
      ru: 'Гигиена с Airflow',
      ro: 'Igienă Dentară cu Airflow',
    },
    hygieneAirflowPrice: { en: '£150', ua: '£130', ru: '£130', ro: '£130' },
    whitening: {
      en: 'Teeth Whitening',
      ua: 'Відбілювання',
      ru: 'Отбеливание',
      ro: 'Albirea Dinților',
    },
    whiteningPrice: {
      en: 'from £250',
      ua: 'від £250',
      ru: 'от £250',
      ro: 'de la £250',
    },
    extraction: {
      en: 'Tooth Extraction',
      ua: 'Видалення зуба',
      ru: 'Удаление зуба',
      ro: 'Extracția Dinților',
    },
    extractionPrice: {
      en: 'from £150',
      ua: 'від £150',
      ru: 'от £150',
      ro: 'de la £150',
    },
    wisdomTooth: {
      en: 'Wisdom Tooth Extraction',
      ua: 'Видалення зуба мудрості',
      ru: 'Удаление зуба мудрости',
      ro: 'Extracția Molarului de Minte',
    },
    wisdomToothPrice: {
      en: 'from £200',
      ua: 'від £200',
      ru: 'от £200',
      ro: 'de la £200',
    },
    veneer: {
      en: 'Porcelain Veneer',
      ua: 'Керамічний вінір',
      ru: 'Керамический винир',
      ro: 'Fațetă din Porțelan',
    },
    veneerPrice: {
      en: 'from £650',
      ua: 'від £500',
      ru: 'от £500',
      ro: 'de la £500',
    },
    compositeBonding: {
      en: 'Composite Bonding (per tooth)',
      ua: 'Композитна реставрація (1 зуб)',
      ru: 'Композитная реставрация (1 зуб)',
      ro: 'Bonding Compozit (per dinte)',
    },
    compositeBondingPrice: {
      en: 'from £250',
      ua: 'від £170',
      ru: 'от £170',
      ro: 'de la £170',
    },
    implant: {
      en: 'Dental Implant',
      ua: 'Зубний імплант',
      ru: 'Зубной имплант',
      ro: 'Implant Dentar',
    },
    implantPrice: {
      en: 'from £1,800',
      ua: 'від £1,800',
      ru: 'от £1,800',
      ro: 'de la £1,800',
    },
    bridge: {
      en: 'Dental Bridge (per unit)',
      ua: 'Зубний міст (1 одиниця)',
      ru: 'Зубной мост (1 единица)',
      ro: 'Punte Dentară (per unitate)',
    },
    bridgePrice: {
      en: 'from £500',
      ua: 'від £450',
      ru: 'от £450',
      ro: 'de la £450',
    },
    denture: {
      en: 'Partial Denture',
      ua: 'Частковий протез',
      ru: 'Частичный протез',
      ro: 'Proteză Parțială',
    },
    denturePrice: {
      en: 'from £600',
      ua: 'від £550',
      ru: 'от £550',
      ro: 'de la £550',
    },
    fullDenture: {
      en: 'Full Denture',
      ua: 'Повний протез',
      ru: 'Полный протез',
      ro: 'Proteză Totală',
    },
    fullDenturePrice: {
      en: 'from £900',
      ua: 'від £850',
      ru: 'от £850',
      ro: 'de la £850',
    },
    emergencyAppointment: {
      en: 'Emergency Appointment',
      ua: 'Екстрений прийом',
      ru: 'Экстренный прием',
      ro: 'Consultație de Urgență',
    },
    emergencyAppointmentPrice: { en: '£50', ua: '£50', ru: '£50', ro: '£50' },
    bookCta: {
      en: 'Book Your Consultation',
      ua: 'Записатись на консультацію',
      ru: 'Записаться на консультацию',
      ro: 'Programați o Consultație',
    },
  },

  // Location CTA
  location: {
    title: {
      en: 'Visit us in Angel, Islington',
      ua: 'Завітайте до нас в Angel',
      ru: 'Приходите к нам в Angel',
      ro: 'Vizitați-ne în Angel, Islington',
    },
    description: {
      en: 'Conveniently located at 360-364 City Rd, London EC1V 2PY. We are open late evenings and weekends for your convenience.',
      ua: 'Зручне розташування за адресою 360-364 City Rd, London EC1V 2PY. Ми працюємо у вечірній час та вихідні.',
      ru: 'Удобное расположение по адресу 360-364 City Rd, London EC1V 2PY. Мы работаем в вечернее время и выходные.',
      ro: 'Situat convenabil la 360-364 City Rd, Londra EC1V 2PY. Suntem deschiși seara târziu și în weekend pentru confortul dumneavoastră.',
    },
    getDirections: {
      en: 'Get Directions',
      ua: 'Маршрут',
      ru: 'Маршрут',
      ro: 'Obțineți Indicații',
    },
    bookAppointment: {
      en: 'Book Appointment',
      ua: 'Записатись',
      ru: 'Записаться',
      ro: 'Programare',
    },
  },

  // Footer
  footer: {
    location: { en: 'Location', ua: 'Локація', ru: 'Локация', ro: 'Locație' },
    hours: {
      en: 'Opening Hours',
      ua: 'Години роботи',
      ru: 'Часы работы',
      ro: 'Program de Lucru',
    },
    contact: {
      en: 'Contact Us',
      ua: 'Контакти',
      ru: 'Контакты',
      ro: 'Contactați-ne',
    },
    address: {
      en: '360-364 City Rd, London EC1V 2PY',
      ua: '360-364 City Rd, London EC1V 2PY',
      ru: '360-364 City Rd, London EC1V 2PY',
      ro: '360-364 City Rd, Londra EC1V 2PY',
    },
    rights: {
      en: 'All rights reserved.',
      ua: 'Всі права захищено.',
      ru: 'Все права защищены.',
      ro: 'Toate drepturile rezervate.',
    },
    whatsappChat: {
      en: 'WhatsApp Chat',
      ua: 'WhatsApp Чат',
      ru: 'WhatsApp Чат',
      ro: 'Chat WhatsApp',
    },
    monFri: { en: 'Mon - Fri', ua: 'Пн - Пт', ru: 'Пн - Пт', ro: 'Lun - Vin' },
    saturday: { en: 'Saturday', ua: 'Субота', ru: 'Суббота', ro: 'Sâmbătă' },
    sunday: { en: 'Sunday', ua: 'Неділя', ru: 'Воскресенье', ro: 'Duminică' },
    closed: { en: 'Closed', ua: 'Зачинено', ru: 'Закрыто', ro: 'Închis' },
    legal: {
      title: {
        en: 'Legal',
        ua: 'Юридична інформація',
        ru: 'Юридическая информация',
        ro: 'Informații Legale',
      },
      privacyPolicy: {
        en: 'Privacy Policy',
        ua: 'Політика конфіденційності',
        ru: 'Политика конфиденциальности',
        ro: 'Politica de Confidențialitate',
      },
      cookiePolicy: {
        en: 'Cookie Policy',
        ua: 'Політика cookies',
        ru: 'Политика cookies',
        ro: 'Politica de Cookie-uri',
      },
      patientPrivacy: {
        en: 'Patient Privacy Notice',
        ua: 'Повідомлення про конфіденційність пацієнта',
        ru: 'Уведомление о конфиденциальности пациента',
        ro: 'Notificare privind Confidențialitatea Pacientului',
      },
      terms: {
        en: 'Terms & Conditions',
        ua: 'Умови використання',
        ru: 'Условия использования',
        ro: 'Termeni și Condiții',
      },
    },
  },

  // Callback Form
  callbackForm: {
    title: {
      en: 'Request a Call Back',
      ua: 'Запит на зворотний дзвінок',
      ru: 'Запрос на обратный звонок',
      ro: 'Solicitați un Apel',
    },
    subtitle: {
      en: 'Leave your details and our team will contact you to arrange your appointment.',
      ua: "Залиште ваші дані, і ми зв'яжемося з вами для запису на прийом.",
      ru: 'Оставьте ваши данные, и мы свяжемся с вами для записи на приём.',
      ro: 'Lăsați-vă detaliile și echipa noastră vă va contacta pentru a programa o consultație.',
    },
    firstName: { en: 'First name', ua: "Ім'я", ru: 'Имя', ro: 'Prenume' },
    lastName: { en: 'Last name', ua: 'Прізвище', ru: 'Фамилия', ro: 'Nume' },
    phone: {
      en: 'Phone number',
      ua: 'Номер телефону',
      ru: 'Номер телефона',
      ro: 'Număr de telefon',
    },
    email: { en: 'Email', ua: 'Email', ru: 'Email', ro: 'Email' },
    preferredLanguage: {
      en: 'Preferred language',
      ua: 'Бажана мова',
      ru: 'Предпочитаемый язык',
      ro: 'Limba preferată',
    },
    message: {
      en: 'Message (optional)',
      ua: "Повідомлення (необов'язково)",
      ru: 'Сообщение (необязательно)',
      ro: 'Mesaj (opțional)',
    },
    messagePlaceholder: {
      en: 'How can we help?',
      ua: 'Чим ми можемо допомогти?',
      ru: 'Чем мы можем помочь?',
      ro: 'Cum vă putem ajuta?',
    },
    submitButton: {
      en: 'Request Call Back',
      ua: 'Замовити дзвінок',
      ru: 'Заказать звонок',
      ro: 'Solicitați Apel',
    },
    privacyConsent: {
      en: 'I have read and agree to the Privacy Policy and Patient Privacy Notice.',
      ua: 'Я ознайомився(лась) і погоджуюся з Політикою конфіденційності та Повідомленням про конфіденційність пацієнта.',
      ru: 'Я ознакомился(лась) и соглашаюсь с Политикой конфиденциальности и Уведомлением о конфиденциальности пациента.',
      ro: 'Am citit și sunt de acord cu Politica de Confidențialitate și Notificarea privind Confidențialitatea Pacientului.',
    },
    marketingConsent: {
      en: 'I agree to receive occasional updates and offers from Dentico Clinic by email/SMS/phone.',
      ua: 'Я погоджуюсь отримувати періодичні новини та пропозиції від Dentico Clinic (email/SMS/телефон).',
      ru: 'Я согласен(на) получать периодические новости и предложения от Dentico Clinic (email/SMS/телефон).',
      ro: 'Sunt de acord să primesc actualizări și oferte ocazionale de la Dentico Clinic prin email/SMS/telefon.',
    },
    whatsappConsent: {
      en: 'I agree to be contacted via WhatsApp regarding my enquiry/appointment.',
      ua: "Я погоджуюсь на зв'язок через WhatsApp щодо мого запиту/запису.",
      ru: 'Я согласен(на) на связь через WhatsApp по моему запросу/записи.',
      ro: 'Sunt de acord să fiu contactat prin WhatsApp cu privire la solicitarea/programarea mea.',
    },
    legalText: {
      en: 'By submitting this form, you confirm you have read our Privacy Policy and Patient Privacy Notice.',
      ua: 'Надсилаючи цю форму, ви підтверджуєте, що ознайомилися з нашою Політикою конфіденційності та Повідомленням про конфіденційність пацієнта.',
      ru: 'Отправляя эту форму, вы подтверждаете, что ознакомились с нашей Политикой конфиденциальности и Уведомлением о конфиденциальности пациента.',
      ro: 'Prin trimiterea acestui formular, confirmați că ați citit Politica noastră de Confidențialitate și Notificarea privind Confidențialitatea Pacientului.',
    },
    successTitle: {
      en: 'Thank you',
      ua: 'Дякуємо',
      ru: 'Спасибо',
      ro: 'Mulțumim',
    },
    successMessage: {
      en: 'We received your request and will contact you shortly.',
      ua: "Ми отримали ваш запит і скоро з вами зв'яжемося.",
      ru: 'Мы получили ваш запрос и скоро с вами свяжемся.',
      ro: 'Am primit solicitarea dumneavoastră și vă vom contacta în curând.',
    },
    errorMessage: {
      en: 'Something went wrong. Please try again or call us directly.',
      ua: 'Сталася помилка. Спробуйте ще раз або зателефонуйте нам напряму.',
      ru: 'Произошла ошибка. Попробуйте снова или позвоните нам напрямую.',
      ro: 'Ceva nu a funcționat. Vă rugăm să încercați din nou sau să ne sunați direct.',
    },
    required: {
      en: 'Required',
      ua: "Обов'язково",
      ru: 'Обязательно',
      ro: 'Obligatoriu',
    },
    invalidEmail: {
      en: 'Invalid email',
      ua: 'Невірний email',
      ru: 'Неверный email',
      ro: 'Email invalid',
    },
    languageOptions: {
      english: { en: 'English', ua: 'English', ru: 'English', ro: 'Engleză' },
      ukrainian: {
        en: 'Ukrainian',
        ua: 'Українська',
        ru: 'Украинский',
        ro: 'Ucraineană',
      },
      russian: { en: 'Russian', ua: 'Російська', ru: 'Русский', ro: 'Rusă' },
      romanian: {
        en: 'Romanian',
        ua: 'Румунська',
        ru: 'Румынский',
        ro: 'Română',
      },
    },
  },

  // About Page
  about: {
    title: {
      en: 'About Dentico Clinic',
      ua: 'Про Dentico Clinic',
      ru: 'О Dentico Clinic',
      ro: 'Despre Dentico Clinic',
    },
    subtitle: {
      en: 'A modern private dental practice in the heart of Angel, dedicated to providing exceptional care in a relaxed environment.',
      ua: 'Сучасна приватна стоматологія в серці Angel, де ви можете почуватися як вдома.',
      ru: 'Современная частная стоматология в сердце Angel, где вы можете чувствовать себя как дома.',
      ro: 'O clinică stomatologică privată modernă în inima Angel, dedicată oferirii de îngrijire excepțională într-un mediu relaxat.',
    },
    storyTitle: {
      en: 'Our Story',
      ua: 'Наша історія',
      ru: 'Наша история',
      ro: 'Povestea Noastră',
    },
    storyP1: {
      en: 'Founded with a vision to transform the dental experience, Dentico Clinic brings together advanced technology and compassionate care. We believe that visiting the dentist should be a positive experience.',
      ua: 'Dentico Clinic створена з метою змінити уявлення про стоматологію. Ми поєднали передові технології з щирою турботою про пацієнтів. Особливу увагу ми приділяємо комфорту наших українських пацієнтів у Лондоні.',
      ru: 'Dentico Clinic создана с целью изменить представление о стоматологии. Мы объединили передовые технологии с искренней заботой о пациентах. Особое внимание мы уделяем комфорту наших русскоязычных пациентов в Лондоне.',
      ro: 'Fondată cu viziunea de a transforma experiența stomatologică, Dentico Clinic reunește tehnologia avansată și îngrijirea plină de compasiune. Credem că vizita la dentist ar trebui să fie o experiență pozitivă.',
    },
    storyP2: {
      en: 'Located conveniently in Angel, Islington, our modern facility is designed for your comfort. From routine check-ups to complex cosmetic makeovers, our team is here to support your journey to a healthy, confident smile.',
      ua: 'Розташована в зручному районі Angel, наша клініка оснащена найсучаснішим обладнанням. Наші лікарі розмовляють українською, тому ви можете бути впевнені, що вас зрозуміють правильно.',
      ru: 'Расположенная в удобном районе Angel, наша клиника оснащена самым современным оборудованием. Наши врачи говорят по-русски, поэтому вы можете быть уверены, что вас поймут правильно.',
      ro: 'Situată convenabil în Angel, Islington, clinica noastră modernă este concepută pentru confortul dumneavoastră. De la controale de rutină la transformări cosmetice complexe, echipa noastră este aici pentru a vă sprijini călătoria către un zâmbet sănătos și încrezător.',
    },
    meetTeam: {
      en: 'Contact Us',
      ua: "Зв'язатись з нами",
      ru: 'Связаться с нами',
      ro: 'Contactați-ne',
    },
    valuesTitle: {
      en: 'Our Core Values',
      ua: 'Наші цінності',
      ru: 'Наши ценности',
      ro: 'Valorile Noastre Fundamentale',
    },
    valuesSubtitle: {
      en: 'These principles guide everything we do at Dentico Clinic.',
      ua: 'Принципи, якими ми керуємося в роботі кожного дня.',
      ru: 'Принципы, которыми мы руководствуемся в работе каждый день.',
      ro: 'Aceste principii ghidează tot ceea ce facem la Dentico Clinic.',
    },
    values: {
      patientCare: {
        title: {
          en: 'Patient Care',
          ua: 'Турбота про пацієнта',
          ru: 'Забота о пациенте',
          ro: 'Grija pentru Pacient',
        },
        desc: {
          en: 'We treat every patient with kindness, respect, and empathy.',
          ua: 'Ми ставимося до кожного пацієнта з добротою та повагою.',
          ru: 'Мы относимся к каждому пациенту с добротой и уважением.',
          ro: 'Tratăm fiecare pacient cu bunătate, respect și empatie.',
        },
      },
      trust: {
        title: {
          en: 'Trust & Transparency',
          ua: 'Довіра та прозорість',
          ru: 'Доверие и прозрачность',
          ro: 'Încredere și Transparență',
        },
        desc: {
          en: 'Clear treatment plans and honest pricing with no hidden fees.',
          ua: 'Чіткі плани лікування та чесні ціни без прихованих платежів.',
          ru: 'Понятные планы лечения и честные цены без скрытых платежей.',
          ro: 'Planuri de tratament clare și prețuri oneste, fără taxe ascunse.',
        },
      },
      nativeLanguage: {
        title: {
          en: 'Modern Technology',
          ua: 'Рідна мова',
          ru: 'Родной язык',
          ro: 'Tehnologie Modernă',
        },
        desc: {
          en: 'Using the latest digital dentistry for precise and comfortable treatments.',
          ua: 'Спілкування українською мовою для вашого повного комфорту.',
          ru: 'Общение на русском языке для вашего полного комфорта.',
          ro: 'Folosim cea mai recentă stomatologie digitală pentru tratamente precise și confortabile.',
        },
      },
      expertTeam: {
        title: {
          en: 'Expert Team',
          ua: 'Команда експертів',
          ru: 'Команда экспертов',
          ro: 'Echipă de Experți',
        },
        desc: {
          en: 'Highly qualified UK-registered clinicians dedicated to your oral health.',
          ua: 'Висококваліфіковані лікарі, віддані своїй справі.',
          ru: 'Высококвалифицированные врачи, преданные своему делу.',
          ro: 'Medici înalt calificați, dedicați sănătății dumneavoastră orale.',
        },
      },
    },
    ctaTitle: {
      en: 'Join Our Patient Community',
      ua: 'Запишіться на прийом',
      ru: 'Запишитесь на прием',
      ro: 'Alăturați-vă Comunității Noastre de Pacienți',
    },
    ctaSubtitle: {
      en: 'Experience the difference of modern, patient-centered dental care.',
      ua: 'Відчуйте різницю сучасної стоматології з рідною мовою.',
      ru: 'Почувствуйте разницу современной стоматологии с родным языком.',
      ro: 'Experimentați diferența unei îngrijiri stomatologice moderne, centrate pe pacient.',
    },
  },

  // Contact Page
  contact: {
    title: {
      en: 'Contact Us',
      ua: 'Наші контакти',
      ru: 'Наши контакты',
      ro: 'Contactați-ne',
    },
    subtitle: {
      en: "We're here to help. Get in touch to book an appointment or ask any questions.",
      ua: "Ми завжди раді допомогти. Зв'яжіться з нами українською мовою.",
      ru: 'Мы всегда рады помочь. Свяжитесь с нами на русском языке.',
      ro: 'Suntem aici să vă ajutăm. Contactați-ne pentru a programa o consultație sau pentru orice întrebări.',
    },
    getInTouch: {
      en: 'Get in Touch',
      ua: 'Наші контакти',
      ru: 'Наши контакты',
      ro: 'Contactați-ne',
    },
    address: { en: 'Address', ua: 'Адреса', ru: 'Адрес', ro: 'Adresă' },
    visitUs: { en: 'Visit Us', ua: 'Адреса', ru: 'Адрес', ro: 'Vizitați-ne' },
    whatsapp: {
      en: 'WhatsApp',
      ua: 'WhatsApp',
      ru: 'WhatsApp',
      ro: 'WhatsApp',
    },
    whatsappDesc: {
      en: 'The fastest way to reach us',
      ua: "Найшвидший спосіб зв'язку",
      ru: 'Самый быстрый способ связи',
      ro: 'Cel mai rapid mod de a ne contacta',
    },
    chatOnWhatsapp: {
      en: 'Message on WhatsApp',
      ua: 'Написати в WhatsApp',
      ru: 'Написать в WhatsApp',
      ro: 'Mesaj pe WhatsApp',
    },
    email: { en: 'Email', ua: 'Email', ru: 'Email', ro: 'Email' },
    instagram: {
      en: 'Instagram',
      ua: 'Instagram',
      ru: 'Instagram',
      ro: 'Instagram',
    },
    instagramDesc: {
      en: 'Follow our work and latest updates',
      ua: 'Слідкуйте за нашими роботами та оновленнями',
      ru: 'Следите за нашими работами и обновлениями',
      ro: 'Urmăriți munca noastră și ultimele noutăți',
    },
    openingHours: {
      en: 'Opening Hours',
      ua: 'Години роботи',
      ru: 'Часы работы',
      ro: 'Program de Lucru',
    },
  },

  // Services Page
  servicesPage: {
    title: {
      en: 'Our Services',
      ua: 'Наші Послуги',
      ru: 'Наши Услуги',
      ro: 'Serviciile Noastre',
    },
    subtitle: {
      en: 'We offer a comprehensive range of private dental treatments using the latest technology and techniques.',
      ua: 'Ми пропонуємо повний спектр приватних стоматологічних послуг з використанням найновіших технологій.',
      ru: 'Мы предлагаем полный спектр частных стоматологических услуг с использованием новейших технологий.',
      ro: 'Oferim o gamă completă de tratamente stomatologice private folosind cele mai noi tehnologii și tehnici.',
    },
    bookConsultation: {
      en: 'Book Consultation',
      ua: 'Записатись на консультацію',
      ru: 'Записаться на консультацию',
      ro: 'Programați o Consultație',
    },
    readyToBook: {
      en: 'Ready to book your appointment?',
      ua: 'Готові записатись?',
      ru: 'Готовы записаться?',
      ro: 'Sunteți gata să vă programați?',
    },
    readyToBookDesc: {
      en: 'Our friendly team is ready to welcome you to Dentico Clinic.',
      ua: 'Наша привітна команда готова вітати вас у Dentico Clinic.',
      ru: 'Наша приветливая команда готова приветствовать вас в Dentico Clinic.',
      ro: 'Echipa noastră prietenoasă este gata să vă întâmpine la Dentico Clinic.',
    },
    bookOnlineNow: {
      en: 'Book Online Now',
      ua: 'Записатись онлайн',
      ru: 'Записаться онлайн',
      ro: 'Programare Online Acum',
    },
    contactUs: {
      en: 'Contact Us',
      ua: 'Контакти',
      ru: 'Контакты',
      ro: 'Contactați-ne',
    },
  },

  // Google Reviews
  reviews: {
    title: {
      en: 'Patient Reviews',
      ua: 'Відгуки пацієнтів',
      ru: 'Отзывы пациентов',
      ro: 'Recenzii Pacienți',
    },
    subtitle: {
      en: 'Rated 4.9/5 on Google',
      ua: 'Реальні відгуки з Google',
      ru: 'Реальные отзывы из Google',
      ro: 'Evaluat 4.9/5 pe Google',
    },
    disclaimer: {
      en: 'Showing selected 5★ reviews from Google.',
      ua: 'Показано вибрані 5★ відгуки з Google.',
      ru: 'Показаны избранные 5★ отзывы из Google.',
      ro: 'Afișând recenzii selectate de 5★ de pe Google.',
    },
    viewAllButton: {
      en: 'View all reviews on Google',
      ua: 'Дивитися всі відгуки в Google',
      ru: 'Смотреть все отзывы в Google',
      ro: 'Vedeți toate recenziile pe Google',
    },
    leaveReview: {
      en: 'Leave a Google Review',
      ua: 'Залишити відгук у Google',
      ru: 'Оставить отзыв в Google',
      ro: 'Lăsați o Recenzie pe Google',
    },
    viewAll: {
      en: 'View all reviews on Google Maps',
      ua: 'Дивитись всі відгуки на Google Maps',
      ru: 'Смотреть все отзывы на Google Maps',
      ro: 'Vedeți toate recenziile pe Google Maps',
    },
    noReviews: {
      en: 'Reviews are temporarily unavailable.',
      ua: 'Відгуки тимчасово недоступні.',
      ru: 'Отзывы временно недоступны.',
      ro: 'Recenziile sunt temporar indisponibile.',
    },
    review1: {
      name: {
        en: 'Sarah J.',
        ua: 'Оксана М.',
        ru: 'Александр В.',
        ro: 'Maria I.',
      },
      text: {
        en: 'Absolutely amazing experience. The staff is so professional and the clinic is spotless. Highly recommend!',
        ua: 'Чудова клініка! Дуже приємно, що можна спілкуватися рідною мовою. Лікарі професіонали.',
        ru: 'Отличная клиника! Очень удобно, что врачи говорят по-русски. Рекомендую.',
        ro: 'Experiență absolut uimitoare. Personalul este foarte profesionist și clinica este impecabilă. Recomand cu căldură!',
      },
      date: {
        en: '2 weeks ago',
        ua: '2 тижні тому',
        ru: '2 недели назад',
        ro: 'acum 2 săptămâni',
      },
    },
    review2: {
      name: {
        en: 'Michael T.',
        ua: 'Андрій К.',
        ru: 'Наталья С.',
        ro: 'Andrei P.',
      },
      text: {
        en: 'Best dental clinic in Angel. Very transparent pricing and excellent care.',
        ua: 'Найкраща стоматологія в Лондоні. Сучасне обладнання та приємні ціни.',
        ru: 'Прекрасный сервис и профессиональные врачи. Очень довольна результатом.',
        ro: 'Cea mai bună clinică stomatologică din Angel. Prețuri foarte transparente și îngrijire excelentă.',
      },
      date: {
        en: '1 month ago',
        ua: '1 місяць тому',
        ru: '1 месяц назад',
        ro: 'acum 1 lună',
      },
    },
    review3: {
      name: {
        en: 'Elena K.',
        ua: 'Марія П.',
        ru: 'Дмитрий И.',
        ro: 'Elena D.',
      },
      text: {
        en: 'Finally found a dentist I can trust. The team made me feel very comfortable.',
        ua: 'Дуже задоволена візитом. Все пройшло безболісно і комфортно.',
        ru: 'Лучшая стоматология в районе Angel. Цены адекватные, качество на высоте.',
        ro: 'În sfârșit am găsit un dentist în care pot avea încredere. Echipa m-a făcut să mă simt foarte confortabil.',
      },
      date: {
        en: '2 months ago',
        ua: '2 місяці тому',
        ru: '2 месяца назад',
        ro: 'acum 2 luni',
      },
    },
    review4: {
      name: {
        en: 'James R.',
        ua: 'Ірина Л.',
        ru: 'Елена К.',
        ro: 'Alexandru M.',
      },
      text: {
        en: 'Excellent service from start to finish. The dentist explained everything clearly and the treatment was painless.',
        ua: 'Професійний підхід та уважне ставлення. Рекомендую всім українцям у Лондоні!',
        ru: 'Профессиональный подход и внимательное отношение. Рекомендую всем!',
        ro: 'Serviciu excelent de la început până la sfârșit. Dentistul a explicat totul clar și tratamentul a fost nedureros.',
      },
      date: {
        en: '3 weeks ago',
        ua: '3 тижні тому',
        ru: '3 недели назад',
        ro: 'acum 3 săptămâni',
      },
    },
    review5: {
      name: { en: 'Anna P.', ua: 'Тетяна В.', ru: 'Михаил Д.', ro: 'Ioana C.' },
      text: {
        en: 'Modern equipment and very friendly staff. My whole family comes here now.',
        ua: 'Сучасна клініка з привітним персоналом. Тепер вся родина лікується тут.',
        ru: 'Современная клиника с приветливым персоналом. Теперь вся семья лечится здесь.',
        ro: 'Echipament modern și personal foarte prietenos. Toată familia mea vine aici acum.',
      },
      date: {
        en: '1 month ago',
        ua: '1 місяць тому',
        ru: '1 месяц назад',
        ro: 'acum 1 lună',
      },
    },
    review6: {
      name: {
        en: 'David M.',
        ua: 'Олександр Г.',
        ru: 'Анна С.',
        ro: 'Cristian B.',
      },
      text: {
        en: 'Great experience! Clean, professional, and the prices are very fair for Central London.',
        ua: 'Чудовий досвід! Чисто, професійно, і ціни дуже справедливі.',
        ru: 'Отличный опыт! Чисто, профессионально, и цены очень справедливые.',
        ro: 'Experiență grozavă! Curat, profesionist, iar prețurile sunt foarte corecte pentru Londra Centrală.',
      },
      date: {
        en: '2 weeks ago',
        ua: '2 тижні тому',
        ru: '2 недели назад',
        ro: 'acum 2 săptămâni',
      },
    },
  },

  // Trust Badge (for UA/RU/RO)
  trustBadge: {
    title: { en: '', ua: 'Рідна мова', ru: 'Родной язык', ro: '' },
    description: {
      en: '',
      ua: "Лікуйтесь комфортно без мовного бар'єру",
      ru: 'Лечитесь комфортно без языкового барьера',
      ro: '',
    },
  },
}

// Helper function to get translation
export function t(key: string, lang: Language): string {
  const keys = key.split('.')
  let value: any = translations

  for (const k of keys) {
    if (value && typeof value === 'object' && k in value) {
      value = value[k]
    } else {
      return key
    }
  }

  if (value && typeof value === 'object' && lang in value) {
    return value[lang]
  }

  return key
}
